export const SEARCH_ARTISTS = "SEARCH_ARTISTS";
export const SELECTED_ARTIST = "SELECTED_ARTIST";
export const SELECTED_SUBSCRIPTION = "SELECTED_SUBSCRIPTION";

//Action Creator
export const setSearchKey = (data) => {
    return { type: SEARCH_ARTISTS, data }
}

export const setArtistItem = (data) => {
    return { type: SELECTED_ARTIST, data }
}

export const setSubscriptionItem = (data) => {
    return { type: SELECTED_SUBSCRIPTION, data }
}
